export interface AboutPageData {
    heroTitle: string;
    heroSubtitle: string;
    heroImage: string;
    heroDescription: string;
    mission: {
        title: string;
        content: string;
    };
    story: {
        title: string;
        subtitle: string;
        content: string[];
    };
    values: {
        title: string;
        items: { icon: string; title: string; description: string }[];
    };
    certifications: {
        title: string;
        subtitle: string;
        items: { icon: string; title: string; description: string }[];
    };
    sustainability: {
        title: string;
        subtitle: string;
        content: string;
        points: { icon: string; text: string }[];
    };
    numbers: {
        title: string;
        items: { number: string; label: string }[];
    };
    vision: {
        title: string;
        content: string;
    };
}

export const aboutData: AboutPageData = {
    heroTitle: 'Our Story',
    heroSubtitle: '',
    heroImage: '/images/about-hero.png',
    heroDescription: 'Wij zijn meer dan een foodtruck. FrietPlus combineert de authentieke Belgische frietcultuur met moderne service en premium kwaliteit. Elk evenement verdient dat beetje extra.',

    mission: {
        title: 'Een man met een missie',
        content: 'Het is mijn passie om mensen te laten genieten van eerlijk en heerlijk eten. Met FrietPlus breng ik niet alleen verse frietjes, maar een totale beleving naar uw evenement.'
    },

    story: {
        title: 'Ons Verhaal',
        subtitle: 'Van Passie naar Premium',
        content: [
            'Na jaren de droom te koesteren en in 2019 een opleiding tot friturist gevolgd te hebben, stel ik met enthousiasme mijn foodtruck Frietplus voor.',
            'Een foodtruck on the road voor al jouw events, thuis of op locatie. Vertrekkende vanuit mijn thuisbasis in Dworp (Vlaams Brabant) verzorg ik de catering voor uw event.',
            'Mijn passie voor lekker eten en koken, zorgt ervoor dat ik steeds op zoek ben naar kwalitatieve verse ingrediënten.',
            'Frietplus levert naast verse, krokante frietjes en frituursnacks heel wat huisgemaakte bereidingen uit de Belgische keuken bereid met vers kwaliteitsvlees van de hoeveslager: vol au vent, balletjes in tomatensaus, steak tartaar, stoofvlees,... Telkens gemaakt met heel veel liefde en passie en met oog voor kwalitatieve producten uit eigen streek.',
            'De rijkelijk gevulde hambugers van Frietplus worden gebakken op de bakplaat en samengesteld uit verse ingridienten van de beste kwaliteit. Wij zorgen ook voor de lekkerste vegetarische burgers.',
            'Ook de aperitiefhapjes worden zorgvuldig geselecteerd.',
            'Graag een totaalbeleving inclusief dessert? Dan zorgt Frietplus ook voor een lekker huisgemaakt dessert.'
        ]
    },

    values: {
        title: 'Onze Waarden',
        items: [
            {
                icon: 'fas fa-medal',
                title: 'Kwaliteit Boven Alles',
                description: 'We maken geen compromissen. Dagverse aardappelen, handgesneden volgens de Belgische traditie. Geen diepvries, nooit.'
            },
            {
                icon: 'fas fa-flag',
                title: 'Belgische Traditie',
                description: 'Trots op onze roots. De perfecte baktechniek, tweemaal gebakken voor die iconische knapperigheid. Respect voor het ambacht.'
            },
            {
                icon: 'fas fa-rocket',
                title: 'Moderne Service',
                description: 'Professioneel, efficiënt, digitaal waar het kan. Van snelle offertes tot digitale facturatie - wij maken het makkelijk.'
            },
            {
                icon: 'fas fa-heart',
                title: 'Echte Gastvrijheid',
                description: 'Iedereen voelt zich welkom bij onze truck. Ons team serveert niet alleen friet, maar ook warmte en een glimlach.'
            },
            {
                icon: 'fas fa-leaf',
                title: 'Duurzaam Ondernemen',
                description: 'Lokale leveranciers, eco-verpakkingen, minimale verspilling. Wij nemen verantwoordelijkheid voor onze impact.'
            }
        ]
    },

    certifications: {
        title: 'Certificeringen & Compliance',
        subtitle: 'Uw Zekerheid, Onze Standaard',
        items: [
            {
                icon: 'fas fa-shield-alt',
                title: 'FAVV Gecertificeerd',
                description: 'Volledige certificering van het Federaal Agentschap voor de Veiligheid van de Voedselketen. Jaarlijks geïnspecteerd.'
            },
            {
                icon: 'fas fa-file-contract',
                title: '€2M Verzekering',
                description: 'Uitgebreide aansprakelijkheidsverzekering voor complete gemoedsrust bij elk event.'
            },
            {
                icon: 'fas fa-clipboard-check',
                title: 'HACCP Compliant',
                description: 'Strikte naleving van alle hygiëne- en voedselveiligheidsprotocollen. Gedocumenteerd en traceerbaar.'
            },
            {
                icon: 'fas fa-user-check',
                title: 'VOG Personeel',
                description: 'Al ons personeel dat op kinderfeestjes werkt beschikt over een actuele Verklaring Omtrent het Gedrag.'
            },
            {
                icon: 'fas fa-graduation-cap',
                title: 'Allergie Training',
                description: 'Volledig team getraind in allergenen herkenning en veilige bereiding voor gasten met dieetwensen.'
            },
            {
                icon: 'fas fa-truck',
                title: 'Mobiele Vergunning',
                description: 'Alle benodigde vergunningen voor ambulante handel in heel België.'
            }
        ]
    },

    sustainability: {
        title: 'Duurzaamheid',
        subtitle: 'Onze Verantwoordelijkheid',
        content: 'Wij geloven dat lekker eten en duurzaam ondernemen hand in hand gaan. Daarom maken we bewuste keuzes in elke stap van ons proces.',
        points: [
            { icon: 'fas fa-map-marker-alt', text: 'Belgische aardappelen van lokale telers' },
            { icon: 'fas fa-recycle', text: 'Biologisch afbreekbare verpakkingen' },
            { icon: 'fas fa-chart-pie', text: 'Nauwkeurige portieberekening tegen verspilling' },
            { icon: 'fas fa-hand-holding-heart', text: 'Overtollig eten naar voedselbanken' },
            { icon: 'fas fa-bolt', text: 'Energiezuinige apparatuur' },
            { icon: 'fas fa-route', text: 'Geoptimaliseerde routes voor minder uitstoot' }
        ]
    },

    numbers: {
        title: 'FrietPlus in Cijfers',
        items: [
            { number: '5+', label: 'Jaar Ervaring' },
            { number: '1000+', label: 'Events Verzorgd' },
            { number: '100%', label: 'On-Time Record' },
            { number: '4.9', label: 'Google Rating' },
            { number: '98%', label: 'Klanttevredenheid' },
            { number: '5000', label: 'Max. Capaciteit/Dag' }
        ]
    },

    vision: {
        title: 'Onze Visie',
        content: 'FrietPlus streeft ernaar DE referentie te worden voor premium mobiele friet in België. Niet door de grootste te zijn, maar door de beste te zijn. Door duurzame partnerships te bouwen, te blijven innoveren, en bij elk event weer te bewijzen dat premium en foodtruck perfect samengaan. De Belgische frietcultuur verdient het beste - en dat leveren wij.'
    }
};
